var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.52769 14.5277L8.03692 10H8.96308L10.4723 14.5277L15 16.0369V16.9631L10.4723 18.4723L8.96308 23H8.03692L6.52769 18.4723L2 16.9631V16.0369L6.52769 14.5277Z",
    fill: "url(#paint0_linear_33432_26274)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.611 7.61099L17.4813 5H18.5187L19.389 7.61099L22 8.48133V9.51867L19.389 10.389L18.5187 13H17.4813L16.611 10.389L14 9.51867V8.48133L16.611 7.61099Z",
    fill: "url(#paint1_linear_33432_26274)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 24V18C19 17.4696 19.2107 16.9609 19.5858 16.5858C19.9609 16.2107 20.4696 16 21 16C21.5304 16 22.0391 16.2107 22.4142 16.5858C22.7893 16.9609 23 17.4696 23 18V24M19 21H23M27 16V24",
    stroke: "url(#paint2_linear_33432_26274)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33432_26274",
    x1: 17.8493,
    y1: 4.48497,
    x2: 2.19987,
    y2: 26.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514656,
    stopColor: "#9D00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E600FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33432_26274",
    x1: 20.3726,
    y1: 3.08187,
    x2: 2.84429,
    y2: 27.5865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514656,
    stopColor: "#9D00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E600FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33432_26274",
    x1: 27,
    y1: 16.2321,
    x2: 19,
    y2: 23.7679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3714FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D00FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.e1a61b1b48cf6ac350138b01d80ac67c.svg";
export { ForwardRef as ReactComponent };